import Vue from 'vue'
import App from './App.vue'
import VueCodemirror from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './plugins/element.js'


Vue.use(ElementUI)
Vue.use(VueCodemirror)
Vue.config.productionTip = false

new Vue({
  el: '#app',
  render: h => h(App)
});